/**
 * SelfTaskBadge Component
 * Displays a "Self" badge when the task creator is also the assignee
 * (i.e., user created a task for themselves)
 */

import Badge from '@/components/ui/core/Badge';
import { IconUser } from '@tabler/icons-react';
import { isSelfTask } from '../utils/taskHelpers';
import { useAuth } from '@actschurch/ccms-sdk';

interface SelfTaskBadgeProps {
  task: Record<string, any>;
  size?: 'xs' | 'sm' | 'md';
}

export function SelfTaskBadge({ task, size = 'xs' }: SelfTaskBadgeProps) {
  let currentUserId: string | undefined;

  try {
    const auth = useAuth();
    currentUserId = auth?.state?.user?.userId ?? undefined;
  } catch {
    // If useAuth is not available, we can't determine self-task
    return null;
  }

  if (!isSelfTask(task, currentUserId)) {
    return null;
  }

  return (
    <Badge
      color="grape"
      variant="light"
      size={size}
      leftSection={<IconUser size={10} />}
    >
      Self
    </Badge>
  );
}
